import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.log('Error caught by boundary:', error, errorInfo);
    
    // Check if this is a SignWell-related error
    if (error.toString().includes('postMessage') || 
        error.toString().includes('SignWell')) {
      // Just log it without showing error UI
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className="error-container">Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 